export const MoreHorizontalIcon = ({
  ...props
}: React.ComponentProps<"svg">) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99992 12.6667C10.3681 12.6667 10.6666 12.3682 10.6666 12C10.6666 11.6318 10.3681 11.3333 9.99992 11.3333C9.63173 11.3333 9.33325 11.6318 9.33325 12C9.33325 12.3682 9.63173 12.6667 9.99992 12.6667Z"
      fill="currentColor"
    />
    <path
      d="M14.6667 12.6667C15.0349 12.6667 15.3333 12.3682 15.3333 12C15.3333 11.6318 15.0349 11.3333 14.6667 11.3333C14.2985 11.3333 14 11.6318 14 12C14 12.3682 14.2985 12.6667 14.6667 12.6667Z"
      fill="currentColor"
    />
    <path
      d="M5.33341 12.6667C5.7016 12.6667 6.00008 12.3682 6.00008 12C6.00008 11.6318 5.7016 11.3333 5.33341 11.3333C4.96522 11.3333 4.66675 11.6318 4.66675 12C4.66675 12.3682 4.96522 12.6667 5.33341 12.6667Z"
      fill="currentColor"
    />
    <path
      d="M9.99992 12.6667C10.3681 12.6667 10.6666 12.3682 10.6666 12C10.6666 11.6318 10.3681 11.3333 9.99992 11.3333C9.63173 11.3333 9.33325 11.6318 9.33325 12C9.33325 12.3682 9.63173 12.6667 9.99992 12.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 12.6667C15.0349 12.6667 15.3333 12.3682 15.3333 12C15.3333 11.6318 15.0349 11.3333 14.6667 11.3333C14.2985 11.3333 14 11.6318 14 12C14 12.3682 14.2985 12.6667 14.6667 12.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33341 12.6667C5.7016 12.6667 6.00008 12.3682 6.00008 12C6.00008 11.6318 5.7016 11.3333 5.33341 11.3333C4.96522 11.3333 4.66675 11.6318 4.66675 12C4.66675 12.3682 4.96522 12.6667 5.33341 12.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
